import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import AnchorContext from './context';
import ConfigContext from '../config-provider/ConfigContext';
import { usePrevious } from '../_utils/hooks';

var AnchorLink = function AnchorLink(props) {
  var customPrefixcls = props.prefixCls,
      href = props.href,
      title = props.title,
      children = props.children,
      className = props.className,
      isFirstLevel = props.isFirstLevel;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var anchorLinkPrefixCls = getPrefixCls(prefixCls, 'anchor', customPrefixcls); // 锚点样式前缀

  var _useContext2 = useContext(AnchorContext),
      activeLink = _useContext2.activeLink,
      scrollTo = _useContext2.scrollTo,
      onClick = _useContext2.onClick,
      type = _useContext2.type,
      registerLink = _useContext2.registerLink;

  var prevHref = usePrevious(href);
  var mounting = useRef(true);
  useEffect(function () {
    if (mounting.current) {
      registerLink(href);
      mounting.current = false;
      return;
    }

    if (prevHref !== href) {
      registerLink(href);
    }
  }, [href, registerLink, prevHref]);

  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, {
      title: title,
      href: href
    });
    scrollTo(href);
  };

  var renderAnchorLink = function renderAnchorLink() {
    var _classNames2;

    var active = activeLink === href;
    var anchorLinkClasses = classNames("".concat(anchorLinkPrefixCls, "-link"), _defineProperty({}, "".concat(anchorLinkPrefixCls, "-link-active"), active), className);
    var titleClassName = classNames("".concat(anchorLinkPrefixCls, "-link-title"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(anchorLinkPrefixCls, "-link-title-active"), active), _defineProperty(_classNames2, "".concat(anchorLinkPrefixCls, "-link-title-secondary"), !isFirstLevel && type === 'bookmarks'), _classNames2));
    return /*#__PURE__*/React.createElement("div", {
      className: anchorLinkClasses
    }, /*#__PURE__*/React.createElement("span", {
      title: typeof title === 'string' ? title : '',
      className: titleClassName,
      onClick: handleClick
    }, title), type !== 'menu' && children);
  };

  return renderAnchorLink();
};

export default AnchorLink;